import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Select, DatePicker } from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

const { Option } = Select;

const SalesAddForm = ({ visible, onCreate, onCancel }) => {

  const [form] = Form.useForm();
  const [customerData, setCustomerData] = useState()
  const [vehilceData, setVehilceData] = useState()

  useEffect(() => {
    //${FetchVariable.Heroku}
      fetch([`${FetchVariable.Heroku}/customer`])
        .then(response => response.json())
        .then(data => {
            setCustomerData(data);
        })
        .catch(err => console.log(err));
    }, []); // eslint-disable-line

    useEffect(() => {
        //${FetchVariable.Heroku}
          // fetch([`${FetchVariable.Heroku}/vehicle/vehicle-for-sale-detail`])
          fetch([`${FetchVariable.Heroku}/vehicle/vehicle-for-sale-detail/`])
            .then(response => response.json())
            .then(data => {
                setVehilceData(data);
            })
            .catch(err => console.log(err));
        }, []); // eslint-disable-line

  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="SalesForm"
        initialValues={{
            SalesDate:'',
            PaymentMethod:'',
            CustomerID: '',
            VehicleID: ''
      }}
      >
        <Form.Item name="SalesDate" label="Sales Date" rules={[{ required: true, message: 'Please select sales date!' }]}>
            <DatePicker format={"YYYY-MM-DD"} />
        </Form.Item>
        
        <Form.Item name="PaymentMethod" label="Payment Method" rules={[{ required: true, message: 'Please select Payment Method!' }]}>
            <Select >
                <Option value="Cash">Cash</Option>
                <Option value="Check">Check</Option>
                <Option value="N/A">N/A</Option>
              </Select>
        </Form.Item>
        <Form.Item name='CustomerID' label="Customer Name" rules={[{ required: true, message: 'Please select customer!' }]}>
            <Select
            showSearch
            placeholder="Select a customer"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {customerData?.map(customer => <Option value={customer.CustomerID} key={customer.CustomerID}>{customer.CustomerName}</Option>)}
            </Select>
        </Form.Item>
        <Form.Item name='VehicleID' label="Vehicle VIN" rules={[{ required: true, message: 'Please select Vehicle VIN!' }]}>
        <Select
            showSearch
            placeholder="Search VIN"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {vehilceData?.map(vehicle => <Option value={vehicle.VehicleID} key={vehicle.VehicleID}>{vehicle.VehicleVIN} : {vehicle.Make} {vehicle.Model}</Option>)}
            </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const SalesAdd = ( props) => {

  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.addSales(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
        Create New Sale
      </Button>
      <SalesAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default SalesAdd